export interface StripeProduct {
  id: string;
  type: StripeProductType;
  name: string;
  callLimitation: number;
}

export enum StripeProductStatus {
  trial = 'trial',
  paid = 'paid',
  expired = 'expired',
}

export enum StripeProductType {
  basic = 'basic',
  premium = 'premium',
}
